/**
 * Notification API Service
 *
 * Handles all notification-related API calls including fetching,
 * marking as read, and deleting notifications.
 */

import api from './api';
import type {
  Notification,
  NotificationsResponse,
  UnreadCountResponse,
  MarkAsReadResponse,
} from '../types/notification';

export const notificationService = {
  /**
   * Get all notifications for the current user
   */
  async getNotifications(page: number = 1): Promise<NotificationsResponse> {
    const response = await api.get(`/api/notifications?page=${page}`);
    return response.data;
  },

  /**
   * Get unread notification count
   */
  async getUnreadCount(): Promise<UnreadCountResponse> {
    const response = await api.get('/api/notifications/unread-count');
    return response.data;
  },

  /**
   * Mark a specific notification as read
   */
  async markAsRead(id: string): Promise<MarkAsReadResponse> {
    const response = await api.post(`/api/notifications/${id}/mark-as-read`);
    return response.data;
  },

  /**
   * Mark all notifications as read
   */
  async markAllAsRead(): Promise<MarkAsReadResponse> {
    const response = await api.post('/api/notifications/mark-all-as-read');
    return response.data;
  },

  /**
   * Delete a notification
   */
  async deleteNotification(id: string): Promise<void> {
    await api.delete(`/api/notifications/${id}`);
  },
};
